import { isEmpty } from '@sgme/fp';
import { useData } from 'components/common-form/hooks/useData';
import { FormattedNumber } from 'components/shared/Intl';
import { FC, Fragment } from 'react';
import { useSelector } from 'react-redux';
import type { FICCGreek } from 'state/quotes/details/details.model';
import { getUserPreferencesGreeksPrecision } from 'state/selectors';

import type { ProductNodeBuilderProps } from '../ProductNodeBuilder.model';

export const SensitivitiesField: FC<ProductNodeBuilderProps> = ({ node: { id }, tabIndex }) => {
  const [sensitivities] = useData<FICCGreek[]>(id);
  const greeksPrecision = useSelector(getUserPreferencesGreeksPrecision);

  if (isEmpty(sensitivities)) {
    return null;
  }
  return (
    <div data-e2e={`${id}-row`} className="d-flex flex-column fs-6 px-2">
      {sensitivities.map((sensitivity, index) => (
        <Fragment key={sensitivity.title}>
          <div className="d-flex flex-column">
            {sensitivity.values?.map((sensiValue, index) => (
              <div
                className="d-flex align-items-center justify-content-between gap-3 py-1"
                key={`${sensitivity.title}${index}`}
              >
                <span className="min-width-0 flex-grow-1 text-secondary fw-normal">
                  {index === 0 ? sensitivity.title : ''}
                </span>
                <span className="tabular-figures text-end text-nowrap text-primary" data-e2e="SpotAndGreeks-spot">
                  <FormattedNumber
                    value={sensiValue}
                    minimumFractionDigits={greeksPrecision}
                    maximumFractionDigits={greeksPrecision}
                    tabIndex={tabIndex}
                  />{' '}
                  {sensitivity.units?.[index]}
                </span>
              </div>
            ))}
          </div>
          {sensitivities.length - 1 !== index && <hr className="my-0" />}
        </Fragment>
      ))}
    </div>
  );
};
SensitivitiesField.displayName = 'SensitivitiesField';
